// @flow
/* eslint-disable react/no-danger */
// Inspired by https://github.com/andreypopp/react-time
import React from "react"
import { connect } from "react-redux"
import moment from "moment"
import type Moment from "moment"

import { getLanguageInfo } from "../../services/staticData/index"
import { getFormat, getRidOfZeroMinutes } from "./services/timestampTools"
import type { LanguageInfo } from "../../records/LanguageInfo"

type Connect = {
  language: LanguageInfo,
}

type Props = Connect & {
  value: ?(string | number | Moment),
  format?: string,
  relative?: boolean,
  className?: string,
  machineReadableUtc?: boolean,
}

const Timestamp = ({
  value,
  format: formatFromProps,
  language,
  relative,
  className = "",
  machineReadableUtc,
}: Props) => {
  moment.locale(language.moment)

  const timestamp: Moment =
    moment.isMoment(value) || moment.isDuration(value) ? value : moment(value)
  const machineReadable = timestamp.format(
    machineReadableUtc ? "YYYY-MM-DDTHH:mm:ssZ" : "YYYY-MM-DDTHH:mm:ss",
  )

  let format = getFormat(language, formatFromProps)
  // get rid of minutes when there are 0
  if (moment.isDuration(timestamp) && timestamp.asHours() && !timestamp.minutes()) {
    format = getRidOfZeroMinutes(format)
  }

  const humanReadable =
    (relative && timestamp.fromNow()) || (format && timestamp.format(format)) || null

  return humanReadable ? (
    <time
      className={className}
      dateTime={machineReadable}
      dangerouslySetInnerHTML={{ __html: humanReadable }}
    />
  ) : (
    <time className={className}>{machineReadable}</time>
  )
}

Timestamp.defaultProps = {
  machineReadableUtc: true,
}

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  language: getLanguageInfo(state),
}))(Timestamp)
